// A fresh app install loses the share link it came from. Android gets it
// back through Play's install referrer, iOS through the clipboard; the app
// reads either once on first launch (skmob lib/helper/install_referral.dart).
import { pendingInstallHandoff } from "./gamification/pendingReferral";

/** Play's `referrer` value for the pending share link, or "" when there is none. */
export function playInstallReferrer(now = Date.now()) {
  const handoff = pendingInstallHandoff(now);
  if (!handoff) return "";
  return `siki_ref=${handoff.ref}&siki_link=${encodeURIComponent(handoff.link)}`;
}

function copyWithSelection(text) {
  try {
    const field = document.createElement("textarea");
    field.value = text;
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.focus();
    field.setSelectionRange(0, text.length);
    const copied = document.execCommand("copy");
    document.body.removeChild(field);
    return copied;
  } catch (e) {
    return false;
  }
}

/**
 * Copies the pending share link for the iOS app to find after install.
 * Call it from the tap on the App Store button; it never rejects.
 */
export function copyInstallLink(now = Date.now()) {
  const handoff = pendingInstallHandoff(now);
  if (!handoff) return Promise.resolve(false);
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(handoff.link).then(
      () => true,
      () => copyWithSelection(handoff.link)
    );
  }
  return Promise.resolve(copyWithSelection(handoff.link));
}
